import { isAfter, parseISO, subDays } from 'date-fns';

import { mapRiskZoneV2ChartData } from '@/helpers/mapChartsData';
import { IMonitoredEntity } from '@/api/monitoring/monitoring.types';
import { IRiskZoneV2LimitedDTO } from '@/types/riskZone';
import { ChartData } from '@/types/chartPoint';
import { IEntityDashboardPortfolio } from '@/views/DashboardView/utils/types';

const mapRiskZonesToChartData = (riskZones: IRiskZoneV2LimitedDTO[]): ChartData => {
  if (!riskZones.length) return [];

  const previousDay = subDays(parseISO(riskZones[0].timestamp), 1);
  const lastDayTrend = riskZones.filter(riskZone =>
    isAfter(parseISO(riskZone.timestamp), previousDay),
  );

  return mapRiskZoneV2ChartData(lastDayTrend);
};

export const mapMonitoredEntitiesToRows = (
  entities: IMonitoredEntity[],
): IEntityDashboardPortfolio[] =>
  entities.map(entity => ({
    displayName: entity.displayName || '',
    agioId: entity.agioId,
    type: entity.type || '',
    pd: entity.pd?.pdYear || null,
    severity: entity.dailySeverity,
    observableBalance: entity.latestBalance?.value || null,
    timeSinceAlert: entity.latestImportantAnomalyTimestamp,
    proofOfReservesUrl: entity.proofOfReservesUrl,
    chartData: mapRiskZonesToChartData(entity.riskZonesV2),
  }));
